export default { sha: 'c289dd195c7a17196286a0bb3b7cc947d4805404', buildNumber: 'undefined' }
